// // // import { useState, useEffect } from "react";
// // // import { generateRoomCode } from "../utils/gameLogic";
// // // import { createRoom, joinRoom, makeChoice, nextRound } from "../firebase/roomService";
// // // import useRoom from "../hooks/useRoom";

// // // import HomeScreen   from "./screens/HomeScreen";
// // // import CreateScreen from "./screens/CreateScreen";
// // // import JoinScreen   from "./screens/JoinScreen";
// // // import LobbyScreen  from "./screens/LobbyScreen";
// // // import GameScreen   from "./screens/GameScreen";

// // // import "../styles/global.css";
// // // import "../styles/components.css";

// // // const App = () => {
// // //   const [screen, setScreen]         = useState("home");    // home | create | join | lobby | game
// // //   const [playerName, setPlayerName] = useState("");
// // //   const [joinCode, setJoinCode]     = useState("");
// // //   const [roomCode, setRoomCode]     = useState(null);
// // //   const [playerSlot, setPlayerSlot] = useState(null);      // "p1" | "p2"
// // //   const [myChoice, setMyChoice]     = useState(null);
// // //   const [error, setError]           = useState("");
// // //   const [prevRound, setPrevRound]   = useState(null);

// // //   // Real-time Firebase listener
// // //   const { roomData } = useRoom(roomCode);

// // //   // When opponent joins → move p1 from lobby → game
// // //   useEffect(() => {
// // //     if (screen === "lobby" && roomData?.status === "playing") {
// // //       setScreen("game");
// // //     }
// // //   }, [roomData, screen]);

// // //   // When a new round starts → reset local choice
// // //   useEffect(() => {
// // //     if (roomData?.round && prevRound !== null && roomData.round > prevRound) {
// // //       setMyChoice(null);
// // //     }
// // //     if (roomData?.round) setPrevRound(roomData.round);
// // //   }, [roomData?.round]);

// // //   // ── CREATE ──────────────────────────────────────────────────────
// // //   const handleCreate = async () => {
// // //     if (!playerName.trim()) return setError("Please enter your name!");
// // //     setError("");
// // //     const code = generateRoomCode();
// // //     await createRoom(code, playerName.trim());
// // //     setRoomCode(code);
// // //     setPlayerSlot("p1");
// // //     setPrevRound(1);
// // //     setScreen("lobby");
// // //   };

// // //   // ── JOIN ────────────────────────────────────────────────────────
// // //   const handleJoin = async () => {
// // //     if (!playerName.trim()) return setError("Please enter your name!");
// // //     if (!joinCode.trim())   return setError("Please enter a room code!");
// // //     setError("");
// // //     try {
// // //       const code = joinCode.trim().toUpperCase();
// // //       await joinRoom(code, playerName.trim());
// // //       setRoomCode(code);
// // //       setPlayerSlot("p2");
// // //       setPrevRound(1);
// // //       setScreen("game");
// // //     } catch (e) {
// // //       setError(e.message);
// // //     }
// // //   };

// // //   // ── CHOOSE ──────────────────────────────────────────────────────
// // //   const handleChoice = async (choice) => {
// // //     if (myChoice) return;
// // //     setMyChoice(choice);
// // //     await makeChoice(roomCode, playerSlot, choice);
// // //   };

// // //   // ── NEXT ROUND (host only) ───────────────────────────────────────
// // //   const handleNextRound = async () => {
// // //     if (playerSlot !== "p1" || !roomData) return;
// // //     setMyChoice(null);
// // //     await nextRound(roomCode, roomData);
// // //   };

// // //   return (
// // //     <div className="app">
// // //       {screen === "home" && (
// // //         <HomeScreen
// // //           onCreate={() => { setError(""); setScreen("create"); }}
// // //           onJoin={() => { setError(""); setScreen("join"); }}
// // //         />
// // //       )}

// // //       {screen === "create" && (
// // //         <CreateScreen
// // //           playerName={playerName}
// // //           setPlayerName={setPlayerName}
// // //           onSubmit={handleCreate}
// // //           onBack={() => setScreen("home")}
// // //           error={error}
// // //         />
// // //       )}

// // //       {screen === "join" && (
// // //         <JoinScreen
// // //           playerName={playerName}
// // //           setPlayerName={setPlayerName}
// // //           roomCode={joinCode}
// // //           setRoomCode={setJoinCode}
// // //           onSubmit={handleJoin}
// // //           onBack={() => setScreen("home")}
// // //           error={error}
// // //         />
// // //       )}

// // //       {screen === "lobby" && (
// // //         <LobbyScreen roomCode={roomCode} />
// // //       )}

// // //       {screen === "game" && roomData && (
// // //         <GameScreen
// // //           roomData={roomData}
// // //           playerSlot={playerSlot}
// // //           myChoice={myChoice}
// // //           onChoice={handleChoice}
// // //           onNextRound={handleNextRound}
// // //         />
// // //       )}
// // //     </div>
// // //   );
// // // };

// // // export default App;


// // import { useState, useEffect } from "react";
// // import { generateRoomCode } from "../utils/gameLogic";
// // import { createRoom, joinRoom } from "../firebase/roomService";
// // import useRoom    from "../hooks/useRoom";
// // import useGame    from "../hooks/useGame";
// // import usePolling from "../hooks/usePolling";

// // import HomeScreen   from "./screens/HomeScreen";
// // import CreateScreen from "./screens/CreateScreen";
// // import JoinScreen   from "./screens/JoinScreen";
// // import LobbyScreen  from "./screens/LobbyScreen";
// // import GameScreen   from "./screens/GameScreen";

// // import "../styles/global.css";
// // import "../styles/components.css";

// // const App = () => {
// //   const [screen, setScreen]         = useState("home");    // home | create | join | lobby | game
// //   const [playerName, setPlayerName] = useState("");
// //   const [joinCode, setJoinCode]     = useState("");
// //   const [roomCode, setRoomCode]     = useState(null);
// //   const [playerSlot, setPlayerSlot] = useState(null);      // "p1" | "p2"
// //   const [myChoice, setMyChoice]     = useState(null);
// //   const [error, setError]           = useState("");
// //   const [prevRound, setPrevRound]   = useState(null);

// //   // Real-time Firebase listener
// //   const { roomData } = useRoom(roomCode);

// //   // When opponent joins → move p1 from lobby → game
// //   useEffect(() => {
// //     if (screen === "lobby" && roomData?.status === "playing") {
// //       setScreen("game");
// //     }
// //   }, [roomData, screen]);

// //   // When a new round starts → reset local choice
// //   useEffect(() => {
// //     if (roomData?.round && prevRound !== null && roomData.round > prevRound) {
// //       setMyChoice(null);
// //     }
// //     if (roomData?.round) setPrevRound(roomData.round);
// //   }, [roomData?.round]);

// //   // ── CREATE ──────────────────────────────────────────────────────
// //   const handleCreate = async () => {
// //     if (!playerName.trim()) return setError("Please enter your name!");
// //     setError("");
// //     const code = generateRoomCode();
// //     await createRoom(code, playerName.trim());
// //     setRoomCode(code);
// //     setPlayerSlot("p1");
// //     setPrevRound(1);
// //     setScreen("lobby");
// //   };

// //   // ── JOIN ────────────────────────────────────────────────────────
// //   const handleJoin = async () => {
// //     if (!playerName.trim()) return setError("Please enter your name!");
// //     if (!joinCode.trim())   return setError("Please enter a room code!");
// //     setError("");
// //     try {
// //       const code = joinCode.trim().toUpperCase();
// //       await joinRoom(code, playerName.trim());
// //       setRoomCode(code);
// //       setPlayerSlot("p2");
// //       setPrevRound(1);
// //       setScreen("game");
// //     } catch (e) {
// //       setError(e.message);
// //     }
// //   };

// //   // ── CHOOSE ──────────────────────────────────────────────────────
// //   const handleChoice = async (choice) => {
// //     if (myChoice) return;
// //     setMyChoice(choice);
// //     await makeChoice(roomCode, playerSlot, choice);
// //   };

// //   // ── NEXT ROUND (host only) ───────────────────────────────────────
// //   const handleNextRound = async () => {
// //     if (playerSlot !== "p1" || !roomData) return;
// //     setMyChoice(null);
// //     await nextRound(roomCode, roomData);
// //   };

// //   return (
// //     <div className="app">
// //       {screen === "home" && (
// //         <HomeScreen
// //           onCreate={() => { setError(""); setScreen("create"); }}
// //           onJoin={() => { setError(""); setScreen("join"); }}
// //         />
// //       )}

// //       {screen === "create" && (
// //         <CreateScreen
// //           playerName={playerName}
// //           setPlayerName={setPlayerName}
// //           onSubmit={handleCreate}
// //           onBack={() => setScreen("home")}
// //           error={error}
// //         />
// //       )}

// //       {screen === "join" && (
// //         <JoinScreen
// //           playerName={playerName}
// //           setPlayerName={setPlayerName}
// //           roomCode={joinCode}
// //           setRoomCode={setJoinCode}
// //           onSubmit={handleJoin}
// //           onBack={() => setScreen("home")}
// //           error={error}
// //         />
// //       )}

// //       {screen === "lobby" && (
// //         <LobbyScreen roomCode={roomCode} />
// //       )}

// //       {screen === "game" && roomData && (
// //         <GameScreen
// //           roomData={roomData}
// //           playerSlot={playerSlot}
// //           myChoice={myChoice}
// //           onChoice={handleChoice}
// //           onNextRound={handleNextRound}
// //         />
// //       )}
// //     </div>
// //   );
// // };

// // export default App;


// import { useState, useEffect } from "react";
// import { generateRoomCode }     from "../utils/gameLogic";
// import { createRoom, joinRoom }  from "../firebase/roomService";

// // ── Hooks ──────────────────────────────────────────────────────
// import useRoom    from "../hooks/useRoom";     // Real-time Firebase listener
// import useGame    from "../hooks/useGame";     // Game state + actions
// import usePolling from "../hooks/usePolling";  // Fallback polling

// // ── Screens ────────────────────────────────────────────────────
// import HomeScreen   from "./screens/HomeScreen";
// import CreateScreen from "./screens/CreateScreen";
// import JoinScreen   from "./screens/JoinScreen";
// import LobbyScreen  from "./screens/LobbyScreen";
// import GameScreen   from "./screens/GameScreen";

// // ── Styles ─────────────────────────────────────────────────────
// import "../styles/global.css";
// import "../styles/components.css";

// // ──────────────────────────────────────────────────────────────
// const App = () => {
//   const [screen,     setScreen]     = useState("home");
//   const [playerName, setPlayerName] = useState("");
//   const [joinCode,   setJoinCode]   = useState("");
//   const [roomCode,   setRoomCode]   = useState(null);
//   const [playerSlot, setPlayerSlot] = useState(null); // "p1" | "p2"
//   const [error,      setError]      = useState("");

//   // ── Hook 1: Real-time Firebase listener ───────────────────────
//   const { roomData } = useRoom(roomCode);

//   // ── Hook 2: Fallback polling (activates only if Firebase drops)
//   const { polledData, isConnected } = usePolling(
//     roomCode,
//     3000,
//     !!roomCode && !isConnected
//   );

//   // Prefer live Firebase data; fall back to polled data
//   const activeRoomData = roomData || polledData;

//   // ── Hook 3: All game logic and actions ────────────────────────
//   const {
//     myChoice,
//     myStoredChoice,
//     oppStoredChoice,
//     bothChose,
//     result,
//     showResult,
//     locked,
//     oppReady,
//     me,
//     opp,
//     choose,
//     advanceRound,
//   } = useGame(activeRoomData, roomCode, playerSlot);

//   // ── When p2 joins → move host from lobby → game ───────────────
//   useEffect(() => {
//     if (screen === "lobby" && activeRoomData?.status === "playing") {
//       setScreen("game");
//     }
//   }, [activeRoomData?.status, screen]);

//   // ── CREATE ROOM ───────────────────────────────────────────────
//   const handleCreate = async () => {
//     if (!playerName.trim()) return setError("Please enter your name!");
//     setError("");
//     try {
//       const code = generateRoomCode();
//       await createRoom(code, playerName.trim());
//       setRoomCode(code);
//       setPlayerSlot("p1");
//       setScreen("lobby");
//     } catch (e) {
//       setError("Failed to create room. Check your connection.");
//     }
//   };

//   // ── JOIN ROOM ─────────────────────────────────────────────────
//   const handleJoin = async () => {
//     if (!playerName.trim()) return setError("Please enter your name!");
//     if (!joinCode.trim())   return setError("Please enter a room code!");
//     setError("");
//     try {
//       const code = joinCode.trim().toUpperCase();
//       await joinRoom(code, playerName.trim());
//       setRoomCode(code);
//       setPlayerSlot("p2");
//       setScreen("game");
//     } catch (e) {
//       setError(e.message || "Failed to join room.");
//     }
//   };

//   // ─────────────────────────────────────────────────────────────
//   return (
//     <div className="app">

//       {/* Connection warning banner */}
//       {!isConnected && screen === "game" && (
//         <div style={{
//           position: "fixed", top: 0, left: 0, right: 0,
//           background: "rgba(255,120,0,0.92)",
//           padding: "8px 16px",
//           textAlign: "center",
//           fontFamily: "Orbitron, monospace",
//           fontSize: 11,
//           letterSpacing: "0.08em",
//           color: "#fff",
//           zIndex: 999,
//         }}>
//           ⚠️ Connection unstable — running on backup sync
//         </div>
//       )}

//       {screen === "home" && (
//         <HomeScreen
//           onCreate={() => { setError(""); setScreen("create"); }}
//           onJoin={()   => { setError(""); setScreen("join");   }}
//         />
//       )}

//       {screen === "create" && (
//         <CreateScreen
//           playerName={playerName}
//           setPlayerName={setPlayerName}
//           onSubmit={handleCreate}
//           onBack={() => setScreen("home")}
//           error={error}
//         />
//       )}

//       {screen === "join" && (
//         <JoinScreen
//           playerName={playerName}
//           setPlayerName={setPlayerName}
//           roomCode={joinCode}
//           setRoomCode={setJoinCode}
//           onSubmit={handleJoin}
//           onBack={() => setScreen("home")}
//           error={error}
//         />
//       )}

//       {screen === "lobby" && (
//         <LobbyScreen roomCode={roomCode} />
//       )}

//       {screen === "game" && activeRoomData && (
//         <GameScreen
//           roomData={activeRoomData}
//           playerSlot={playerSlot}
//           myChoice={myChoice}
//           myStoredChoice={myStoredChoice}
//           oppStoredChoice={oppStoredChoice}
//           bothChose={bothChose}
//           result={result}
//           showResult={showResult}
//           locked={locked}
//           oppReady={oppReady}
//           me={me}
//           opp={opp}
//           onChoice={choose}
//           onNextRound={advanceRound}
//         />
//       )}

//     </div>
//   );
// };

// export default App;

import { useState, useEffect } from "react";
import { generateRoomCode }     from "../utils/gameLogic";
import { createRoom, joinRoom }  from "../firebase/roomService";

// ── Hooks ──────────────────────────────────────────────────────
import useRoom    from "../hooks/useRoom";     // Real-time Firebase listener
import useGame    from "../hooks/useGame";     // Game state + actions
import usePolling from "../hooks/usePolling";  // Fallback polling

// ── Screens ────────────────────────────────────────────────────
import HomeScreen   from "./screens/HomeScreen";
import CreateScreen from "./screens/CreateScreen";
import JoinScreen   from "./screens/JoinScreen";
import LobbyScreen  from "./screens/LobbyScreen";
import GameScreen   from "./screens/GameScreen";

// ── Styles ─────────────────────────────────────────────────────
import "../styles/global.css";
import "../styles/components.css";

// ──────────────────────────────────────────────────────────────
const App = () => {
  const [screen,     setScreen]     = useState("home");
  const [playerName, setPlayerName] = useState("");
  const [joinCode,   setJoinCode]   = useState("");
  const [roomCode,   setRoomCode]   = useState(null);
  const [playerSlot, setPlayerSlot] = useState(null); // "p1" | "p2"
  const [error,      setError]      = useState("");

  // ── Hook 1: Real-time Firebase listener ───────────────────────
  const { roomData } = useRoom(roomCode);

  // ── Hook 2: Fallback polling
  // FIX: Do NOT use isConnected inside its own hook call — that causes
  // "Cannot access before initialization" error. Just pass !!roomCode.
  const { polledData, isConnected } = usePolling(roomCode, 3000, !!roomCode);

  // Prefer live Firebase data; fall back to polled data if Firebase drops
  const activeRoomData = roomData || polledData;

  // ── Hook 3: All game logic and actions ────────────────────────
  const {
    myChoice,
    myStoredChoice,
    oppStoredChoice,
    bothChose,
    result,
    showResult,
    locked,
    oppReady,
    me,
    opp,
    choose,
    advanceRound,
  } = useGame(activeRoomData, roomCode, playerSlot);

  // ── When p2 joins → move host from lobby → game ───────────────
  useEffect(() => {
    if (screen === "lobby" && activeRoomData?.status === "playing") {
      setScreen("game");
    }
  }, [activeRoomData?.status, screen]);

  // ── CREATE ROOM ───────────────────────────────────────────────
  const handleCreate = async () => {
    if (!playerName.trim()) return setError("Please enter your name!");
    setError("");
    try {
      const code = generateRoomCode();
      await createRoom(code, playerName.trim());
      setRoomCode(code);
      setPlayerSlot("p1");
      setScreen("lobby");
    } catch (e) {
      console.error("Create room error:", e);
      setError(`Error: ${e.message}`);
    }
  };

  // ── JOIN ROOM ─────────────────────────────────────────────────
  const handleJoin = async () => {
    if (!playerName.trim()) return setError("Please enter your name!");
    if (!joinCode.trim())   return setError("Please enter a room code!");
    setError("");
    try {
      const code = joinCode.trim().toUpperCase();
      await joinRoom(code, playerName.trim());
      setRoomCode(code);
      setPlayerSlot("p2");
      setScreen("game");
    } catch (e) {
      console.error("Join room error:", e);
      setError(e.message || "Failed to join room.");
    }
  };

  // ─────────────────────────────────────────────────────────────
  return (
    <div className="app">

      {/* Connection warning banner — only shows if Firebase drops */}
      {!isConnected && screen === "game" && (
        <div style={{
          position: "fixed", top: 0, left: 0, right: 0,
          background: "rgba(255,120,0,0.92)",
          padding: "8px 16px",
          textAlign: "center",
          fontFamily: "Orbitron, monospace",
          fontSize: 11,
          letterSpacing: "0.08em",
          color: "#fff",
          zIndex: 999,
        }}>
          ⚠️ Connection unstable — running on backup sync
        </div>
      )}

      {/* ── HOME ── */}
      {screen === "home" && (
        <HomeScreen
          onCreate={() => { setError(""); setScreen("create"); }}
          onJoin={()   => { setError(""); setScreen("join");   }}
        />
      )}

      {/* ── CREATE ROOM ── */}
      {screen === "create" && (
        <CreateScreen
          playerName={playerName}
          setPlayerName={setPlayerName}
          onSubmit={handleCreate}
          onBack={() => setScreen("home")}
          error={error}
        />
      )}

      {/* ── JOIN ROOM ── */}
      {screen === "join" && (
        <JoinScreen
          playerName={playerName}
          setPlayerName={setPlayerName}
          roomCode={joinCode}
          setRoomCode={setJoinCode}
          onSubmit={handleJoin}
          onBack={() => setScreen("home")}
          error={error}
        />
      )}

      {/* ── LOBBY (waiting for opponent) ── */}
      {screen === "lobby" && (
        <LobbyScreen roomCode={roomCode} />
      )}

      {/* ── GAME ── */}
      {screen === "game" && activeRoomData && (
        <GameScreen
          roomData={activeRoomData}
          playerSlot={playerSlot}
          myChoice={myChoice}
          myStoredChoice={myStoredChoice}
          oppStoredChoice={oppStoredChoice}
          bothChose={bothChose}
          result={result}
          showResult={showResult}
          locked={locked}
          oppReady={oppReady}
          me={me}
          opp={opp}
          onChoice={choose}
          onNextRound={advanceRound}
        />
      )}

    </div>
  );
};

export default App;